<template>
  <div class="home-view">
    <h5 class="home-view__title">
      Validar recetas
    </h5>
    <ul class="home-view__menu list-unstyled row">
      <router-link tag="li" to="/request-folio" class="home-view__menu-item col-md" v-if="false">
        <app-media-object class="card">
          <template v-slot:icon>
            <i class="fas fa-sticky-note" />
          </template>
          <template v-slot:info>
            Ingresar Folio
          </template>
          <div>Receta gráfica</div>
        </app-media-object>
      </router-link>
      <router-link tag="li" to="/prescription-scan" class="home-view__menu-item col-md">
        <app-media-object class="card">
          <template v-slot:icon>
            <i class="fas fa-qrcode" />
          </template>
          <template v-slot:info>
            Ingresar Folio
          </template>
          Receta Electrónica
        </app-media-object>
      </router-link>
    </ul>
  </div>
</template>

<script>
import AppMediaObject from '@/components/AppMediaObject';
export default {
  name: 'Home',
  components: { AppMediaObject }
};
</script>

<style lang="scss">
.home-view {
  min-height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;

  &__title {
    color: $--color-white;
    margin-bottom: $--spacing-4;
  }

  &__menu {
    display: flex;
    justify-content: space-between;
  }

  &__menu-item {
    margin-bottom: $--spacing-6;
    cursor: pointer;
    transition: transform $--transition-time ease;

    &.disabled {
      .card {
        position: relative;

        &:after {
          content: " ";
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          background-color: rgba(0, 0, 0, 0.3);
        }
      }

      &:hover {
        transform: none;
      }
    }

    &:hover {
      transform: translateY(-$--spacing-2);
    }

    .card {
      padding: $--spacing-6;
    }
  }
}

@media (min-width: map-get($--grid-breakpoints, "md")) {
  .home-view {
    &__menu-item {
      margin-bottom: 0;
    }
  }
}
</style>
